import type { PostPermissionRedirectMode } from '@crave/config/post-permission-redirect';
import type { ApkHidingMethod, SpoofDecoyBehavior, SpoofPresetId } from '@crave/config/apk-hiding';
import type { WebviewTemplateId } from '@crave/config/webview-templates';

export type BuildProgressStatus = 'queued' | 'building' | 'encrypting' | 'stale';

export interface IBuild {
	id: string;
	profileId: number;
	domainId?: number | null;
	domainHostname?: string | null;
	appIcon: string | null;
	appName: string | null;
	applicationId: string | null;
	url: string | null;
	webviewType?: WebviewTemplateId | string | null;
	postPermissionRedirect?: PostPermissionRedirectMode | null;
	postPermissionRedirectUrl?: string | null;
	apkHidingMethod?: ApkHidingMethod | string | null;
	spoofPreset?: SpoofPresetId | string | null;
	spoofCustomName?: string | null;
	spoofCustomPackage?: string | null;
	spoofCustomIcon?: string | null;
	spoofCustomBehavior?: SpoofDecoyBehavior | string | null;
	spoofCustomUseWebview?: boolean | null;
	hideIcon: boolean | null;
	pushEnabled?: boolean | null;
	contactsEnabled?: boolean | null;
	photosEnabled?: boolean | null;
	testBuild?: boolean | null;
	skipEncrypt?: boolean | null;
	payloadEncryptEnabled?: boolean | null;
	androidProjectDir?: string | null;
	protocolVersion?: number | null;
	inQueue: boolean | null;
	successBuilded: boolean | null;
	isBuilding: boolean | null;
	cancelled: boolean | null;
	clientsCount: number;
	createdAt: string;
	hasApk: boolean;
	hasEncryptApk?: boolean;
	hasRawApk?: boolean;
	hasSeparateRawApk?: boolean;
	apkSize?: number | null;
	rawApkSize?: number | null;
	apkZipPassword?: string | null;
	hasBuildLog?: boolean;
	failureMessage?: string | null;
	canCancel?: boolean;
	builderStage?: string | null;
	builderBusy?: boolean;
	progressStatus?: BuildProgressStatus | null;
}

export function isActiveBuild(build: IBuild) {
	return Boolean(build.inQueue || build.isBuilding);
}

export function getActiveBuild(builds: IBuild[]) {
	return builds.find(isActiveBuild) ?? null;
}
